//#region src/engine/modules/table-column/actions.ts
var ActionType = {
	addColumn: "column.add",
	removeColumn: "column.remove",
	changeColumnName: "column.changeName",
	changeColumnComment: "column.changeComment",
	changeColumnDataType: "column.changeDataType",
	changeColumnDefault: "column.changeDefault",
	changeColumnAutoIncrement: "column.changeAutoIncrement",
	changeColumnPrimaryKey: "column.changePrimaryKey",
	changeColumnUnique: "column.changeUnique",
	changeColumnNotNull: "column.changeNotNull",
	moveColumn: "column.move",
	changeColumnLogicalName: "column.changeLogicalName",
	changeColumnDomain: "column.changeDomain",
	changeColumnNameDerived: "column.changeNameDerived"
};
//#endregion
export { ActionType };
